import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

export function BackdropFallback({ children }: Props) {
  return (
    <div className="fixed inset-0 z-[1202] flex items-center justify-center bg-neutral-900/50 text-neutral-white">
      {children}
    </div>
  );
}
